import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function BookSection() {
  return <section id="book" className="py-24 bg-rhino-charcoal relative" data-id="element-37">
      <div className="container mx-auto px-6" data-id="element-38">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-39">
          {/* Book Mockup */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-40">
            <FadeIn direction="right" data-id="element-41">
              <motion.div whileHover={{
              rotateY: -10,
              scale: 1.02
            }} className="relative w-64 md:w-80 aspect-[2/3] perspective-1000" style={{
              perspective: '1000px'
            }} data-id="element-42">
                {/* Book Shadow */}
                <div className="absolute -bottom-8 left-4 right-4 h-8 bg-black/50 blur-xl rounded-full" data-id="element-43"></div>

                {/* Book Cover */}
                <div className="absolute inset-0 bg-gradient-to-br from-rhino-black via-rhino-charcoal to-rhino-black border border-rhino-grey rounded-r-md shadow-2xl flex flex-col justify-between p-8 transform-gpu transition-transform duration-500" style={{
                transformStyle: 'preserve-3d'
              }} data-id="element-44">
                  {/* Spine effect */}
                  <div className="absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-black/60 to-transparent" data-id="element-45"></div>

                  <div className="relative z-10 text-center mt-8" data-id="element-46">
                    <h3 className="font-heading font-bold text-4xl md:text-5xl text-white tracking-tighter leading-none mb-2" data-id="element-47">
                      RHINO
                      <br data-id="element-48" />
                      <span className="text-rhino-gold" data-id="element-49">MIND</span>
                    </h3>
                    <div className="w-12 h-1 bg-rhino-gold mx-auto my-6" data-id="element-50"></div>
                    <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold" data-id="element-51">
                      The Playbook for Victory
                    </p>
                  </div>

                  <div className="relative z-10 text-center" data-id="element-52">
                    <p className="font-heading text-sm text-gray-300 tracking-widest uppercase" data-id="element-53">
                      By Rhino Man
                    </p>
                  </div>
                </div>
              </motion.div>
            </FadeIn>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left" data-id="element-54">
            <FadeIn data-id="element-55">
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-white tracking-wide mb-6" data-id="element-56">
                THE BOOK
              </h2>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-57">
              <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-58">
                Prepare to transform your mindset. The Rhino Mind book is the
                ultimate guide to breaking through barriers, building
                unshakeable discipline, and charging toward your God-given
                potential. It's not just theory; it's a battle-tested strategy
                for life.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-59">
              <button disabled className="px-8 py-4 bg-rhino-grey text-gray-500 font-heading font-bold text-lg tracking-wider uppercase rounded cursor-not-allowed border border-rhino-grey" data-id="element-60">
                Coming Soon
              </button>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="px-8 py-4 bg-rhino-gold text-rhino-black font-heading font-bold text-lg tracking-wider uppercase rounded shadow-[0_0_15px_rgba(212,160,23,0.2)] hover:bg-rhino-gold-hover transition-all" data-id="element-61">
                Get Notified
              </motion.button>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}